class VisitorDetailsRequest {
    VisitorDetailsURL(){
        return process.env.REACT_APP_BASEURL+"VisitorDetails"
    }
}
export const {VisitorDetailsURL}=new VisitorDetailsRequest();